const columns = function () {
    return [
        {
            prop: 'title',
            label: '岗位名称',
        },
        {
            prop: 'content',
            label: '备注'
        },
        {
            prop: 'status',
            label: '状态',
            render({ status }) {
                return status ? '启用' : '禁用'
            }
        },
        {
            prop: 'create_time',
            label: '创建时间',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'handle',
            label: '操作',
            width: 100
        }
    ]
}

const rules = function () {
    return {
        title: [{
            required: true,
            message: '请输入岗位名称',
            trigger: 'blur'
        }]
    }
}

module.exports = {
    columns,
    rules
}
